import { acrKeys, claims, FIELD as FIELDS, FIELD } from './constants';

export const resolveAcrValues = (item, checked, formik) => {
  let values = formik.values._default_acr_values;
  let selected;
  if (values !== null && typeof values == 'object') {
    selected = Object.keys(acrKeys).filter(x => values[x]);
  } else {
    selected = [];
  }
  if (checked) {
    selected.push(item);
  } else {
    selected = selected.filter(items => items !== item);
  }

  let selectedAcrValues = selected.map(item => {
    return acrKeys[item];
  });
  const deDupedAcrValues = [...new Set(selectedAcrValues.flatMap(a => a))];

  formik.setFieldValue(FIELD.DEFAULT_ACR_VALUES, deDupedAcrValues, false);
  // this is for the UI component, not the form
  formik.setFieldValue(`_${FIELD.DEFAULT_ACR_VALUES}.${item}`, checked, false);
};

export const populateScopeMultiSelect = (
  data,
  setSelectedItemsWrapper,
  formik
) => {
  const scopeItems = data.scope
    .split(' ')
    .map(scopeItem => claims.filter(claim => claim.labelText == scopeItem))
    .flat();

  setSelectedItemsWrapper(scopeItems);
};

const populateCheckBoxByProxy = (data, formik) => {
  const values = data.default_acr_values;

  const isSubset = (list, possibleSubset) =>
    possibleSubset.every(item => list.includes(item));

  let obj = {};
  for (const key of Object.keys(acrKeys)) {
    if (isSubset(values, acrKeys[key])) {
      obj[key] = true;
    }
  }
  formik.setFieldValue('_default_acr_values', obj);
};

/*
  converts boolean values to strings (suomifi-components do not allow booleans as values)
 */
const boolsToStrings = obj => {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [
      key,
      typeof value === 'boolean' ? String(value) : value
    ])
  );
};

export const loadJsonFromInputFile = (
  files,
  setSelectedItemsWrapper,
  formik
) => {
  const array = Array.from(files);
  if (array.length > 0) {
    for (const file of array) {
      if (file) {
        const reader = new FileReader();

        reader.onload = e => {
          try {
            const data = JSON.parse(e.target.result);

            let newData = boolsToStrings({
              ...formik.values,
              ...data
            });

            // fields only available on the interactive form must be retained
            // even state is overwritten with data from a metadata output JSON
            newData = {
              ...newData,
              [FIELDS.NO_DECISION]: formik.values[FIELDS.NO_DECISION],
              [FIELDS.DECISION_ID]: formik.values[FIELDS.DECISION_ID],
              [FIELDS.JOURNAL_NUMBER]: formik.values[FIELDS.JOURNAL_NUMBER],
              [FIELDS.LEVEL_OF_PERMIT]: formik.values[FIELDS.LEVEL_OF_PERMIT],
              [FIELDS.ENV]: formik.values[FIELDS.ENV]
            };

            formik.setValues(newData, true);

            // these fields are custom generated interactive fields and ergo must be  populated manually
            populateScopeMultiSelect(newData, setSelectedItemsWrapper, formik);
            populateCheckBoxByProxy(newData, formik);
          } catch (err) {
            console.error('❌ Invalid JSON', err);
          }
        };

        reader.onerror = () => console.error('Read error');
        reader.readAsText(file);
      }
    }
  }
};

export const isValidDate = date =>
  date instanceof Date && !isNaN(date.getTime());
